module.exports = __webpack_public_path__ + "img/66.dcd9fb86.jpg";